import { createSlice } from "@reduxjs/toolkit";
import toolbarConfiguration from "../components/Toolbar/toolbarConfig";

const {
  category,
  sku,
  DC,
  supplier,
  risk_type,
  tier2_suppliers,
  tier2_skus,
  supplier_org,
  assembly_item,
} = toolbarConfiguration.filterMap;

const capacitySlice = createSlice({
  name: "capacity",
  initialState: {
    apiLoading: {
      quadrant: false,
      header: false,
      capacity: false,
      summary: false,
      table: false,
      criticalHeader: false,
      capacityByProduct: false,
      capacityByLocation: false,
      capacitySummaryView: false
    },
    hdrData: {},
    prevHdrData: {},
    criticalHdrData: {},
    prevCriticalHdrData: {},
    criticalSkuGrpIds: {},
    baseRiskData: [],
    capacityAssessmentData: [],
    prevCapacityAssessmentData: [],
    capacityByProduct: [],
    capacityByLocation: [],
    capacitySummaryView: [],
    capacityDates: [],
    tableData: [],
    prevTableData: [],
    summaryData: {},
    prevSummaryData: {},
    filters: {
      [category.filterId]: [],
      [sku.filterId]: [],
      [supplier.filterId]: [],
      [DC.filterId]: [],
      [tier2_suppliers.filterId]: [],
      [tier2_skus.filterId]: [],
      [risk_type.filterId]: [],
      [supplier_org.filterId]: [],
      [assembly_item.filterId]: [],
      country: [],
    },
    resetTriggered: false,
    snapshotDates: []
  },
  reducers: {
    setLoader(state, action) {
      state.apiLoading[action.payload.loaderKey] = action.payload.loaderValue;
    },
    setHdrData(state, action) {
      state.hdrData = action.payload;
    },
    setPrevHdrData(state, action) {
      state.prevHdrData = action.payload;
    },
    setCriticalHdrData(state, action) {
      state.criticalHdrData = action.payload;
    },
    setPrevCriticalHdrData(state, action) {
      state.prevCriticalHdrData = action.payload;
    },
    setCriticalSkuGrpIds(state, action) {
      state.criticalSkuGrpIds = action.payload;
    },
    setFilters(state, action) {
      const { filters, filterId } = action.payload;
      const currentFilters = state.filters;

      if (filterId && filterId !== "status") {
        delete filters[filterId];
      }

      state.filters = {
        ...currentFilters,
        ...filters,
      };
    },
    setCapacityAssessmentData(state, action) {
      state.capacityAssessmentData = action.payload;
    },
    setPrevCapacityAssessmentData(state, action) {
      state.prevCapacityAssessmentData = action.payload;
    },
    setTableData(state, action) {
      state.tableData = action.payload;
    },
    setPrevTableData(state, action) {
      state.prevTableData = action.payload;
    },
    setSummaryData(state, action) {
      state.summaryData = action.payload;
    },
    setPrevSummaryData(state, action) {
      state.prevSummaryData = action.payload;
    },
    setBaseData(state, action) {
      state.baseRiskData = action.payload;
    },
    setCapacityByProduct(state, action) {
      state.capacityByProduct = action.payload;
    },
    setCapacityByLocation(state, action) {
      state.capacityByLocation = action.payload;
    },
    setCapacitySummaryView(state, action) {
      state.capacitySummaryView = action.payload;
    },
    setCapacityDates(state, action) {
      state.capacityDates = action.payload;
    },
    setSnapshotDates(state, action) {
      state.snapshotDates = action.payload;
    },
    setResetTriggered(state, action) {
      state.resetTriggered = action.payload;
    },
  },
});

export const {
  setLoader,
  setHdrData,
  setPrevHdrData,
  setCriticalHdrData,
  setPrevCriticalHdrData,
  setCriticalSkuGrpIds,
  setCapacityAssessmentData,
  setPrevCapacityAssessmentData,
  setTableData,
  setPrevTableData,
  setBaseData,
  setCapacityByProduct,
  setCapacityByLocation,
  setCapacitySummaryView,
  setCapacityDates,
  setSummaryData,
  setPrevSummaryData,
  setFilters,
  setSnapshotDates,
  setResetTriggered,
} = capacitySlice.actions;

export default capacitySlice.reducer;
